import Vue from 'vue'
import Vuex from 'vuex'
import Landing from './store/landing'
import ModalComponent from './store/modalComponent'
import ModalRequestComponent from './store/ModalRequestComponent'
import ModalComponentFooter from './store/modalAlertFooter'
import CommonCode from './store/commonCode'
import userLogin from './store/login'
import ModalAlert from './store/modalAlert'
import Global from './store/global'
import SignUp from './store/signup'
import User from './store/user'
import Service from './store/service'
import Request from './store/request'
import RequestPage from './store/requestPage'
import ModalGoogleMapComponent from './store/ModalGoogleMapComponent'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Landing,
    ModalComponent,
    ModalRequestComponent,
    ModalComponentFooter,
    CommonCode,
    ModalAlert,
    userLogin,
    Global,
    SignUp,
    User,
    Service,
    Request,
    RequestPage,
    ModalGoogleMapComponent
  }
})
